export default "__VITE_ASSET__689744de__"